<template>
  <v-select
    :id="name"
    item-text="label"
    item-value="value"
    class="wabident-selector"
    :options="options"
    placeholder="Categoría de producto ..."
    v-model="selected_category"
    @input="change"
  ></v-select>
</template>

<script>
export default {
  props: ["value", "name"],
  data() {
    return {
      product_hierarchy: [],
      selected_category: null,
    };
  },
  computed: {
    product_categories() {
      let ret = [];
      this.product_hierarchy.forEach((cat) => {
        this.addCategory(cat, ret, 0);
      });
      return ret;
    },
    options() {
      return this.product_categories.map((cat) => {
        return {
          label: cat.data.name,
          value: cat.data.id,
        };
      });
    },
    ...mapGetters(["clinic", "msgwindow"]),
  },
  methods: {
    change(val) {
      if (val) {
        this.$emit("input", val.value);
      } else {
        this.$emit("input", null);
      }
    },
    getCategories() {
      axios
        .get("/product/hierarchy")
        .then((response) => {
          this.product_hierarchy = response.data;
        })
        .catch((err) => {
          console.log("[ERR] getCategories", err);
          this.msgwindow.error("Error buscando categorías de productos");
        });
    },
    addCategory(cat, ret, level) {
      ret.push({
        level: level,
        data: cat,
      });

      cat.children.forEach((subcat) => {
        this.addCategory(subcat, ret, level + 1);
      });
    },
  },
  mounted() {
    this.getCategories();
  },
};
</script>
